import configuration from '../../../utilities/configuration';
import * as EffectUtility from "../../../utilities/EffectUtility";
import KaikoExchangesModel from "../../../models/filterableProducts/kaiko/KaikoExchangesModel";
import KaikoBaseCurrenciesModel from "../../../models/filterableProducts/kaiko/KaikoBaseCurrenciesModel";
import KaikoFilesInfoModel from "../../../models/filterableProducts/kaiko/KaikoFilesInfoModel";
import KaikoPricingPackagesModel from "../../../models/filterableProducts/kaiko/KaikoPricingPackagesModel";

const baseApiPath = configuration.apiServer + configuration.apiFilterableProductsPath;

export async function getExchanges(product, params) {
    const endpoint = baseApiPath + "/" + product + "/levelOne";
    return EffectUtility.getToModel(KaikoExchangesModel, endpoint, params);
}

export async function getBaseCurrencies(product, params) {
    const endpoint = baseApiPath + "/" + product + "/levelTwo";
    return EffectUtility.getToModel(KaikoBaseCurrenciesModel, endpoint, params);
}

export async function getFilesInfo(product, params) {
    const endpoint = baseApiPath + "/" + product + "/filesInfo";
    return EffectUtility.getToModel(KaikoFilesInfoModel, endpoint, params);
}

export async function getPricingPackages(product) {
    const endpoint = baseApiPath + "/" + product + "/packages";
    return EffectUtility.getToModel(KaikoPricingPackagesModel, endpoint);
}

export async function getFilterableSubscriptionFilesInfo(subscriptionTypeId, params) {
    const endpoint = configuration.apiServer + configuration.apiFilterableSubscriptionTypePath + "/" + subscriptionTypeId + "/filesInfo";
    return EffectUtility.getToModel(KaikoFilesInfoModel, endpoint, params);
}

export async function getFilterableSubscriptionPricingPackages(subscriptionTypeId) {
    const endpoint = configuration.apiServer + configuration.apiFilterableSubscriptionTypePath + "/" + subscriptionTypeId + "/packages";
    return EffectUtility.getToModel(KaikoPricingPackagesModel, endpoint);
}